

const TRANSLATIONS_HU_HU = {
    "email_otp.back":"Vissza",
    "email_otp.enter_email_text":"Adja meg az e-mail-címét, hogy küldhessünk önnek egy egyedi kódot",
    "email_otp.send_verification_link":"Ellenőrzőkód küldése",
    "email_otp.resend_otp_with_timer":"Egyszer használatos jelszó újraküldése ennyi időn belül:",
    "email_otp.text":"Küldtünk egy hatjegyű ellenőrzőkódot ide: [email]. Kérjük, adja meg a kódot alább",
    "email_otp.verify":"Ellenőrzés",
    "reset_password.set_password":"Állítsa be a jelszavát",
    "sign_in.or":"vagy",
    "sign_in.continue_with":"Vagy folytassa az alábbiak egyikével",
    "sign_in.continue_with_email":"Vagy folytassa e-mail-címmel",
    "sign_in.create_without_password":"Hozzon létre egy fiókot jelszó nélkül",
    "sign_in.create_with_otp":"Hozzon létre egy fiókot egyszeri jelszóval",
    "sign_in.login_with_otp":"Jelentkezzen be egyszeri jelszóval",
    "sign_in.login_without_password":"Jelentkezzen be jelszó nélkül",
    "sign_in.tooltip_text":"Fiókja eléréséhez kap egy egyedi, ideiglenes ellenőrzőkódot e-mailben.",
    "sign_up.tooltip_text":"Fiókja létrehozásához kap egy egyedi, ideiglenes ellenőrzőkódot e-mailben.",
    "sign_in.password_updated":"Jelszavát frissítettük.",
    "sign_up.create_an_account":"Fiók létrehozása",
    "email_otp.resend_otp":"Egyszer használatos jelszó újraküldése",
    "sign_up.email_address":"e-mail cím",
    "sign_up.password":"Jelszó",
    "sign_in.create_account" : "Fiók létrehozása",
    "sign_in.title": "Bejelentkezés",
    "sign_in.forgot_password" : "Elfelejtette jelszavát?",
    "reset_password.resend_email": "E-mail újraküldése",
    "reset_password.sent_title": "E-mail elküldve!",
    "reset_password.rcvResetLink": "Ajda meg email címét és küldünk egy linket a jelszó visszaállításához.",
    "reset_password.submit": "OK",
    "reset_password.back_to_login": "Vissza a bejelentkezéshez",
    "reset_password.create_new_password": "Hozzon létre új jelszót, hogy be tudjon lépni fiókjába.",
    "forgot_password.emailSent": "Ha a következő e-mail-címhez már tartozik fiók: [], e-mailt küldünk a jelszó visszaállításához szükséges hivatkozással. Még mindig nem jelenik meg? Kérjen egy új e-mailt alább.",
    "gdpr.continue": "Folytatás",
    "validation.password_validation_heading": "A jelszónak tartalmaznia kell:",
    "validation.password_length_ui": "Legalább 8 karakter",
    "validation.password_upper_case_ui": "Egy nagybetűt",
    "validation.password_lower_case_ui": "Egy kisbetűt",
    "validation.password_number_ui": "Egy számot",
    "validation.password_symbol_ui": "Egy speciális karaktert",
    "verify_otp.customer_service_center_link": "s/kapcsolat",
    "activate_user.verification_successful.message": "Gratulálunk! Aktiválta a fiókját.",
    "activate_user.already_verified.message" : "Üdvözöljük újra! Igazolta a fiókját.",

    // Errors Translation
    "sign_in.mandatory_field_error": "A folytatáshoz, kérjük, töltsön ki minden kötelező mezőt.",
    "sign_in.invalid_email_error": "Kérjük, megfelelő formátumban adja meg az e-mail-címet (pl. nev@domain.com).",
    "sign_in.invalid_credentials_error": "A megadott felhasználónév vagy jelszó érvénytelen. Kérjük, próbálja újra.",
    "sign_in.generic_error": "Hiba történt. Kérjük, próbálja újra.",
    "sign_in.account_unverified_error": "Fiókja még nincs aktiválva. Keresse meg az e-mailben kapott aktiváló linket, vagy kattintson az „Elfelejtette jelszavát?” lehetőségre a fiókhozzáférés visszaállításához.",
    "sign_in.max_attempt_error": "Elérte a próbálkozások maximális számát. Próbálja újra később.",
    "sign_in.social_signin_error": "A közösségimédia-fiókkal (Google/Facebook/Apple) történő bejelentkezés sikertelen. Próbálja újra, vagy válasszon egy másik bejelentkezési módot.",
    "sign_in.social_signin_email_not_present_error": "A bejelentkezés sikertelen. Próbálja újra, vagy válasszon egy másik bejelentkezési módot.",
    "sign_in.guest_user_signin_error": "Úgy tűnik, már van fiókja ezzel az e-mail-címmel. Kattintson az „Elfelejtettem a jelszavam” menüpontra, hogy újra hozzáférhessen.",

    "sign_up.mandatory_field_error": "A folytatáshoz, kérjük, töltsön ki minden kötelező mezőt.",
    "sign_up.invalid_email_error": "Kérjük, érvényes e-mail-címet adjon meg (pl. nev@domain.com).",
    "sign_up.password_length_error": "A jelszónak legalább 8 karakter hosszúságúnak kell lennie.",
    "sign_up.email_already_exist_error": "Ez az e-mail-cím már használatban van. Kérjük, használjon másik e-mail-címet.",
    "sign_up.generic_error": "Hiba történt. Kérjük, próbálja újra.",
    "sign_up.password_policy_error": "A jelszónak tartalmaznia kell: egy számot, egy speciális karaktert [!#$%&'*+-/=?^_`{|}~.@], egy nagy- és egy kisbetűt.",
    "sign_up.common_password_error": "A jelszó nem egyezhet meg az e-mail-címével.",

    "forgot_password.mandatory_field_error": "A folytatáshoz, kérjük, töltsön ki minden kötelező mezőt.",
    "forgot_password.invalid_email_error": "Kérjük, megfelelő formátumban adja meg az e-mail-címet (pl. nev@domain.com).",
    "forgot_password.generic_error": "Hiba történt. Kérjük, próbálja újra.",

    "reset_password.mandatory_field_error": "Kérjük, a folytatáshoz töltsön ki minden kötelező mezőt.",
    "reset_password.password_history_error": "A jelszó ne egyezzen meg az előző öt jelszavával",
    "reset_password.password_length_error": "A jelszónak legalább 8 karakter hosszúságúnak kell lennie.",
    "reset_password.password_policy_error": "A jelszónak tartalmaznia kell: egy számot, egy speciális karaktert [!#$%&'*+-/=?^_`{|}~.@], egy nagy- és egy kisbetűt.",
    "reset_password.common_password_error": "A jelszó nem egyezhet meg az e-mail-címével.",
    "reset_password.generic_error": "Hiba történt. Kérjük, próbálja újra.",

    "email_otp.email_required_error": "A folytatáshoz adja meg az e-mail-címét.",
    "email_otp.invalid_email_error": "Kérjük, érvényes e-mail-címet adjon meg (pl. nev@domain.com).",
    "email_otp.generic_error": "Hiba történt. Próbálja újra később.",
    "email_otp.invalid_otp_error": "A megadott egyszer használatos jelszó / ellenőrzőkód érvénytelen. Kérjük, próbálja újra.",
    "email_otp.resend_otp_error": "Nem lehet újraküldeni az egyszer használatos jelszót. Próbálja újra később.",
    "email_otp.verify_otp_error": "Hiba történt. Kérjük, próbálja újra az egyszer használatos jelszó ellenőrzését később.",
    "email_otp.verify_otp_limit_exceed_error": "A megadott egyszer használatos jelszó érvénytelen. Kattintson az „Egyszer használatos jelszó újraküldése” lehetőségre, hogy újat kérjen.",
    "email_otp.max_attempt_reached_error": "Elérte a próbálkozások maximális számát. Próbálja újra később.",
    "email_otp.brute_force_error_part_1": "Fiókját átmenetileg letiltottuk többszöri sikertelen bejelentkezési kísérlet miatt. Kérjük, próbálja újra később, vagy ",
    "email_otp.brute_force_error_part_2": "forduljon a Súgóhoz",
    "email_otp.brute_force_error_part_3": " segítségért.",
    "form.gdprconsent": "A bejelentkezéssel vállalja, hogy elolvasta és elfogadja",
    "form.termsCondition": "*Felhasználási feltételeinket",

    //Page Titles
    "sign_in.page_title": "Bejelentkezés | Pens.com",
    "sign_up.page_title": "Feliratkozás | Pens.com",
    "forgot-password.page_title": "Elfelejtettem a jelszavam | Pens.com",
    "reset-password.page_title": "Jelszó visszaállítása | Pens.com",
    "sign-in.password_icon_aria_label_blured": "Blured Show password",
    "sign-in.password_icon_aria_label": "Show password",
    "sign-in.password_icon_aria_label_hidden": "Hide password",
    "sign-in.tooltip_icon_aria_label": "More Info",
    "email_otp.otp_digit_aria_label": "Please enter the code",
};
export default TRANSLATIONS_HU_HU;